import './_legacy';

// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property, queryAssignedElements } from 'lit/decorators.js';

// Import style for web component
import styles from './web-component-style.scss';

// eslint-disable-next-line require-jsdoc
@customElement( 'uo-button-dropdown' )
export class AutomatorButtonDropdown extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties
	@property( { type: Boolean, attribute: 'reverse-direction' } ) accessor reverseDirection = false;

	// The items inside the dialog content
	@queryAssignedElements( { selector: 'uo-button' } ) accessor $dropdownContentButtons;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div class="dropdown ${ this.reverseDirection ? 'dropdown--reverse-direction' : '' }">
				<div class="dropdown-button">
					<slot name="target"></slot>
				</div>

				<div class="dropdown-content">
					<slot @slotchange=${ this._setButtonStyle }></slot>
				</div>
			</div>
		`;
	}

	/**
	 * Changes the style of the buttons inside the dialog content/list element
	 */
	_setButtonStyle() {
		this.$dropdownContentButtons.forEach( $item => {
			$item.setAttribute( 'color', 'transparent' );
		} );
	}
}
